/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientForms = sqliteTable('patient_forms', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  patient_id: text('patient_id'),
  appointment_id: text('appointment_id'),
  queue_id: text('queue_id'),
  name: text('name'),
  tag: text('tag'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
